import {RouteRecordRaw} from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => import("layouts/OrganizerLayout.vue"),
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("pages/HomePage.vue"),
      },
      {
        path: "tournaments",
        name: "Tournaments",
        component: () => import("pages/TournamentsPage.vue"),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "tournaments/new",
        name: "newTournament",
        component: () => import("pages/NewTournament.vue"),
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "imprint",
        name: "Imprint",
        component: () => import("pages/ImprintPage.vue"),
      },
      {
        path: "data-security",
        name: "DataSecurity",
        component: () => import("pages/DataSecurityPage.vue"),
      },
      {
        path: "feedback",
        name: "Feedback",
        component: () => import("pages/FeedbackPage.vue"),
      },
    ],
  },
  {
    path: "/tournaments/id/:id",
    component: () =>
      import("layouts/TournamentLayout.vue"),
    children: [
      {
        path: "",
        name: "tournamentHome",
        component: () => import("pages/TournamentInfoPage.vue"),
      },
      {
        path: "info",
        name: "tournamentInfo",
        component: () => import("pages/TournamentInfoPage.vue"),
      },
      {
        path: "table",
        name: "tournamentTable",
        component: () => import("pages/TournamentTablePage.vue"),
      },
      {
        path: "round",
        name: "tournamentRound",
        component: () => import("pages/TournamentRoundPage.vue"),
      },
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    name: "ErrorPage",
    component: () => import("pages/ErrorNotFound.vue"),
  },
];

export default routes;
